module.exports = __webpack_public_path__ + "static/media/nPOD.849b17d1.jpg";